<template>
  <div v-loading="allLoading">
    <el-row>
      <el-form
        ref="formInline"
        :inline="true"
        :model="formInline"
        class="demo-form-inline">
        <el-form-item label="员工姓名">
          <el-input
            v-model="formInline.empName"
            style="width: 145px"
            placeholder="请输入员工姓名">
          </el-input>
        </el-form-item>
        <el-form-item label="证件号码">
          <el-input
            v-model="formInline.idCard"
            style="width: 180px"
            placeholder="请输入证件号码">
          </el-input>
        </el-form-item>
        <el-form-item label="所属机构">
          <el-select
            v-model="formInline.orgId"
            placeholder="请选择机构"
            clearable>
            <el-option
              v-for="item in cusOrgList"
              :key="item.id"
              :label="item.orgName"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="startTime" label="开始时间">
          <el-date-picker
            style="width: 145px"
            v-model="formInline.startTime"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择开始时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item prop="endTime" label="结束时间">
          <el-date-picker
            v-model="formInline.endTime"
            style="width: 145px"
            type="date"
            format="yyyy-MM-dd"
            value-format="yyyy-MM-dd"
            placeholder="选择结束时间">
          </el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="onSubmit">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="toExport">导出</el-button>
        </el-form-item>
      </el-form>
    </el-row>
    <div ref="payrollSetting">
      <el-tabs type="card">
        <el-tab-pane label="纪念日提醒">
          <div style="height: calc(100vh - 320px)">
            <vxe-grid
              id="costCenterSummary"
              resizable
              auto-resize
              border
              show-overflow
              show-footer
              ref="xGrid"
              align="center"
              width="100%"
              height="100%"
              :show-header-overflow="true"
              :loading="loading"
              :custom-config="{ storage: true }"
              :data.sync="dataTable">
              <vxe-table-column
                v-for="(column, i) in customList"
                :key="i"
                :title="column.columnName"
                align="center">
                <template v-slot="{ row }">
                  <span>
                    <span>{{ row[column.field] }}</span>
                  </span>
                </template>
              </vxe-table-column>
              <template v-slot:empty>
                <span>
                  <svg
                    class="icon icon-kong"
                    aria-hidden="true"
                    style="font-size: 40px; color: #999">
                    <use xlink:href="#icon-kong"></use>
                  </svg>
                  <p class="noData">暂无数据</p>
                </span>
              </template>
            </vxe-grid>
          </div>
          <vxe-pager
            :loading="loading"
            :current-page="formInline.page"
            :page-size="formInline.limit"
            :total="formInline.total"
            :layouts="[
              'PrevPage',
              'JumpNumber',
              'NextPage',
              'FullJump',
              'Sizes',
              'Total',
            ]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange">
          </vxe-pager>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { getDifferentAnni, exportExcle } from "@/api/wage/ysqh";
import { deepCopy, downloadFile } from "@/util/util";
import { mapGetters } from "vuex";
export default {
  name: "anniversary",
  computed: {
    ...mapGetters(["userInfo"]),
  },
  data() {
    return {
      loading: false,
      formInline: {
        page: 1,
        limit: 10,
        total: 0,
        startTime: "",
        endTime: "",
        empName: "",
        idCard: "",
        orgId: "",
      },
      allLoading: false,
      cusOrgList: [],
      customList: [
        {
          columnName: "雇员姓名",
          field: "a0010002",
        },
        {
          columnName: "证件号码",
          field: "a0010005",
        },
        {
          columnName: "证件类型",
          field: "idcardtype",
        },
        {
          columnName: "一周年",
          field: "firstanni",
        },
        {
          columnName: "三周年",
          field: "thirdanni",
        },
        {
          columnName: "五周年",
          field: "fifthanni",
        },
        {
          columnName: "入职时间",
          field: "a0010039",
        },
      ],
      dataTable: [],
    };
  },
  created() {
      let time = new Date()
      let year = time.getFullYear()
      let month = time.getMonth()+1
      let day = time.getDate()
      if( month > 12 ){
          month = 1;
          year++ 
      }
      let monthLastDay = new Date(year,month,0).getDate();
      this.formInline.startTime=year + '-' + (month < 10 ? '0'+month : month) + '-' + '01';
      this.formInline.endTime = year + '-' + (month < 10 ? '0'+month : month) + '-' + (monthLastDay < 10 ? '0'+monthLastDay : monthLastDay);
      this._getDifferentAnni();
  },
  methods: {
    //查询
    onSubmit() {
        this._getDifferentAnni();
    },
    //获取数据
    _getDifferentAnni(isChange) {
      this.loading = true;
      if(isChange!='N'){
        this.dataTable = [];
        this.formInline['page'] = 1;
      }
      let param = {
        startTime: this.formInline.startTime,
        endTime: this.formInline.endTime,
        cusId: this.userInfo.cusId,
        empName: this.formInline.empName,
        idCard: this.formInline.idCard,
        orgId: this.formInline.orgId,
        page: this.formInline.page,
        limit: this.formInline.limit,
      };
      getDifferentAnni({
        param: JSON.stringify(param),
      }).then((res) => {
        this.loading = false;
        this.allLoading = false;
        if (res.data.code == 0) {
          this.cusOrgList = res.data.data.orgList;
          this.dataTable = res.data.data.anniversaryList;
          if(isChange!='N'){
            this.formInline.total = res.data.data.total
          }
        }
      });
    },
    handleSizeChange(val) {
      this.formInline.limit = val;
      this._getDifferentAnni('N');
      console.log(`每页 ${val} 条`);
    },
    handleCurrentChange(val) {
      this.formInline.page = val;
      this._getDifferentAnni('N');
      console.log(`当前页: ${val}`);
    },
    //导出
    toExport() {
      let column = deepCopy(this.customList);
      let params = {
        columns: column,
        type: "excel",
        fileName: "纪念日提醒明细.xls",
        startTime: this.formInline.startDate,
        endTime: this.formInline.endDate,
        empName: this.formInline.empName,
        cusId: this.userInfo.cusId,
        idCard: this.formInline.idCard,
        orgId: this.formInline.orgId,
        limit: this.formInline.limit,
        page: this.formInline.page,
      };
      if (this.dataTable.length == 0) {
        this.$message.error("暂无数据可以导出！");
        return false;
      } else {
        exportExcle(params).then((res) => {
          downloadFile(res);
        });
      }
    },
  },
};
</script>

<style scoped>
.customerBox >>> .el-tabs__new-tab {
  position: relative;
  top: -6px;
}
.btnCon {
  position: absolute;
  right: 0;
  top: -32px;
}
.el-loading-spinner {
  display: block;
}
.light-theme #main > div.customerBox:not(.home) {
  background: transparent;
  padding: 0;
  box-shadow: none;
}
.tooltip {
  width: 200px;
  display: inline-block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  vertical-align: middle;
  margin-right: 10px;
  font-size: 12px;
  color: #333;
}
.tooltip .icon {
  color: red;
  margin-right: 4px;
}
.gridContain >>> .vxe-body--row .vxe-cell {
  height: 100%;
  padding: 0;
  line-height: 46px;
}
</style>
